import React, { useState, useEffect } from 'react';
import Settings from '../assets/images/settings.png';
import Help from '../assets/images/help.png';
import Avatar from '../assets/images/profile.png';
import { Link } from 'react-router-dom';
import { LuCircleHelp } from "react-icons/lu";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { BsThreeDots } from "react-icons/bs";
import { LuSettings } from "react-icons/lu";
import { useHistory } from "react-router-dom";

import { logOut } from "../store/actions/authActions";
import { connect } from "react-redux";
import { compose } from "redux";
import { useDispatch } from 'react-redux';
import { toggleChatbot } from '../store/actions/chatbotActions';
import { getProfile } from "../store/actions/profileActions";
import {getRisks} from "../store/actions/riskActions";
import SearchBar from "../components/searchBar";
import { PiRabbit } from "react-icons/pi";
import { useTranslation } from "react-i18next";

const LANG_STORAGE_KEY = "rabo_i18n_language";

/** Demo notification pool (keys under topBar.notificationDropdown in common.json) */
const NOTIFICATION_DEMO_POOL = [
    { id: 1, i18nKey: "demoNewRiskDepartment" },
    { id: 2, i18nKey: "demoComplianceReview" },
    { id: 3, i18nKey: "demoActionResolved" },
    { id: 4, i18nKey: "demoAuditDeadline" },
    { id: 5, i18nKey: "demoNewFindingControl" },
    { id: 6, i18nKey: "demoPolicyHealth" },
];

const DropdownMenu = ({ logOutFN, firstName, lastName, avatar }) => {
    const { t } = useTranslation();

    return (
        <div className="absolute right-4 top-12 w-48 bg-white rounded-md border border-gray-300 rounded-[5px] shadow-lg z-10 dropdown-menu">
            <div className="flex items-center cursor-pointer p-2 border-b border-gray-300 mr-2 ml-2">
                <img src={avatar || Avatar} alt={t("topBar.avatarAlt")} className="w-8 h-8 rounded-full mr-2" />
                <span className="text-black text-sm">{firstName} {lastName}</span>
            </div>

            <div className="p-2">  
                <div className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black border-b border-gray-300 mt-[-4px]">
                    <i className="fas fa-user"></i>
                    <span className="ml-2 text-sm"><Link to="/profile">{t("topBar.editProfile")}</Link></span>
                </div>
                <div className="flex items-center p-2 hover:bg-gray-100 cursor-pointer text-black" onClick={() => logOutFN()}>
                    <i className="fas fa-sign-out-alt"></i>
                    <span className="ml-2 text-sm">{t("topBar.logout")}</span>
                </div>
            </div>

        </div>
    );
};

const BsThreeDotsDropdown = ({ isOpen, toggleDropdown }) => {
    const { t } = useTranslation();
    return (
        <div className="relative">
            <div className="hover:bg-white hover:bg-opacity-50 hover:rounded p-2 cursor-pointer text-white " onClick={toggleDropdown}>
                <BsThreeDots/>
            </div>
            {isOpen && (
                <div className="absolute right-[-40px] top-8 w-32 bg-white rounded-md border border-gray-300 rounded-[5px] shadow-lg z-10 dropdown-menu">
                    <Link to="/help" className="flex text-sm items-center space-x-2 p-2 hover:bg-gray-100 border-b border-gray-300 ml-2 mr-2">
                        <LuCircleHelp className="w-4 h-4 text-black" />
                        <span className="text-black">{t("topBar.help")}</span>
                    </Link>
                    <Link to="/settings" className="flex text-sm items-center space-x-2 p-2 hover:bg-gray-100 ml-2 mr-2">
                        <LuSettings className="w-4 h-4 text-black "/>
                        <span className="text-black">{t("topBar.settings")}</span>
                    </Link>
                </div>
            )}
        </div>
    );
};

const ProfileIcon = ({ toggleDropdown, firstName, lastName, avatar }) => {
    const { t } = useTranslation();
    return (
        // <div className="flex items-center justify-center w-8 h-8 rounded-full bg-[#3b3b3b] text-white text-[0.6em] font-bold cursor-pointer dropdown-menu" onClick={toggleDropdown}>
        //     {firstName ? firstName.charAt(0) : ""}
        //     {lastName ? lastName.charAt(0) : ""}
        // </div>
        <div className="flex items-center space-x-2 cursor-pointer dropdown-menu hover:bg-white hover:bg-opacity-50 hover:rounded-full pl-2"  onClick={toggleDropdown}>
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-[#FFFFFF] text-white text-[0.6em] font-bold">
                
                <img src={avatar || Avatar} alt={t("topBar.avatarAlt")} className="w-8 h-8 rounded-full" />
            </div>
        </div>
    );
};

const TopBar = ({ logOutFN, getProfileFN, profile }) => {
    const { t, i18n } = useTranslation();
    useEffect(() => {
        getProfileFN();
    }, [getProfileFN]);

    useEffect(() => {
        const saved = localStorage.getItem(LANG_STORAGE_KEY);
        if (saved === "en" || saved === "tr") {
            i18n.changeLanguage(saved);
        }
    }, [i18n]);

    const setLanguage = (lng) => {
        i18n.changeLanguage(lng);
        localStorage.setItem(LANG_STORAGE_KEY, lng);
    };

    const activeLang = i18n.resolvedLanguage || i18n.language || "en";
    const isEn = activeLang === "en" || activeLang.startsWith("en");
    const isTr = activeLang === "tr" || activeLang.startsWith("tr");

    const dispatch = useDispatch();

    const routerHistory = useHistory();
    const firstName = profile?.first_name || "";
    const lastName = profile?.last_name || "";
    const avatar = profile?.avatar || Avatar;

    const [isOpen, setIsOpen] = useState(false);
    const [isThreeDotsDropdownOpen, setThreeDotsDropdownOpen] = useState(false);

    const toggleDropdown = () => {
        setIsOpen((prev) => {
            if (isThreeDotsDropdownOpen) setThreeDotsDropdownOpen(false);
            return !prev;
        });
    };

    const toggleThreeDotsDropdown = () => {
        setThreeDotsDropdownOpen((prev) => {
            if (isOpen) setIsOpen(false);
            return !prev;
        });
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.dropdown-menu')) {
                setIsOpen(false);
                setThreeDotsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const [showNotifications, setShowNotifications] = React.useState(false);
    const [notifications, setNotifications] = React.useState([]);

    const toggleNotifications = () => {
        if (!showNotifications) {
            const shuffled = [...NOTIFICATION_DEMO_POOL].sort(() => 0.5 - Math.random());
            setNotifications(shuffled.slice(0, 3));
        }
        setShowNotifications((s) => !s);
    };


    return (

        <header className="bg-[#F0F0F0] text-blue1 flex justify-between items-center p-4 border-b border-b-1 border-gray-300 shadow-sm"> 
      
            <h1 className="m-0 text-2xl font-bold text-[#3b3b3b]">{t("app.name")}</h1>



             <div className="flex items-center space-x-2">
        <HiChevronLeft
          onClick={() => routerHistory.goBack()}
          size={24}
          className="cursor-pointer text-[#3b3b3b] hover:text-black"
        />
        <HiChevronRight
          onClick={() => routerHistory.goForward()}
          size={24}
          className="cursor-pointer text-[#3b3b3b] hover:text-black"
        />
      
            <div className="relative">
                    <SearchBar
                        profile = {profile}
                    />
                </div>
            </div>

            <div className="flex space-x-4 mr-4">

                {/* <Link to="/help"><MdHelp alt="Help" className="w-6 h-6 text-[#3b3b3b]" /></Link>
                <Link to="/settings"><img src={Settings} alt="Settings" className="w-6 h-6" /></Link>
                <ProfileIcon toggleDropdown={toggleDropdown} firstName={firstName} lastName={lastName} /> */}
                {/* <BsThreeDots className="mt-2"/> */}
                
                {/* <div className="">
                    <BsThreeDotsDropdown
                        isOpen={isThreeDotsDropdownOpen}
                        toggleDropdown={toggleThreeDotsDropdown}
                    />
                </div> */}

                <div className="relative">
  {/* Bell icon */}
 <button
  onClick={toggleNotifications}
  className="relative p-2 rounded-lg hover:bg-gray-100 transition-colors"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5 text-gray-600"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.8}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 17h5l-1.4-1.4A2 2 0 0 1 18 14.2V11a6 6 0 1 0-12 0v3.2c0 .5-.2 1-.6 1.4L4 17h5m6 0a3 3 0 0 1-6 0"
    />
  </svg>

  {/* unread dot */}
  <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full" />
</button>


  {/* Dropdown */}
  {showNotifications && (
    <div className="absolute right-0 mt-2 w-72 bg-white border border-gray-200 rounded-xl shadow-lg z-50">
      <div className="px-4 py-2 border-b border-gray-100 text-sm font-medium text-gray-700">
        {t("topBar.notificationDropdown.title")}
      </div>

      <div className="divide-y">
        {notifications.map((n) => (
          <div
            key={n.id}
            className="px-4 py-3 text-sm text-gray-700 hover:bg-gray-50 cursor-pointer"
          >
            {t(`topBar.notificationDropdown.${n.i18nKey}`)}
          </div>
        ))}
      </div>
    </div>
  )}
</div>
                <div className="flex items-center space-x-4">
                    <ProfileIcon toggleDropdown={toggleDropdown} firstName={firstName} lastName={lastName} avatar={avatar} />
                </div>
                {/* <button onClick={() => dispatch(toggleChatbot())}>
                    <PiRabbit className="w-6 h-6  text-[#3b3b3b] hover:text-black" />
                </button> */}
            </div>
            {isOpen && <DropdownMenu logOutFN={logOutFN} firstName={firstName} lastName={lastName} avatar={avatar} />}
        </header>
    );
};

const mapStateToProps = (state) => {
    return {


        profile: state.profile.profile,
        


    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        logOutFN: () => dispatch(logOut()),
        getProfileFN: () => dispatch(getProfile()),
        getRisksFN: (currentPage, pageSize, department_id, sortBy) => dispatch(getRisks(currentPage, pageSize, department_id, sortBy)),

    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(TopBar);



